export const GROUPING_MODE = {
  SUMMARY: "SUMMARY",
  BY_INSURED: "BY_INSURED",
  BY_SCENARIO: "BY_SCENARIO",
};
